<div #triggerButton class="select-wrapper" [style.marginBottom]="marginBottom">
  <button
    class="select-button"
    [class.active]="isOpen"
    [class.disabled]="disabled || locked"
    [class.locked]="locked && showLockIcon"
    [disabled]="disabled"
    [ngClass]="[size]"
    [attr.aria-disabled]="locked ? 'true' : null"
    [attr.tabindex]="locked ? -1 : null"
    (click)="openDropdown()"
  >
    <ng-container *ngIf="selectedTemplate; else defaultSelectedOption">
      <ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: selectedOption }"></ng-container>
    </ng-container>
    <ng-template #defaultSelectedOption>
      <div class="label">
        @if (selectedOption) {
          @if (selectedOption.icon) {
            <i [ngClass]="selectedOption.icon"></i>
          } @else if (selectedOption.img) {
            <img [src]="selectedOption.img" />
          }
        }

        <span>
          {{
            selectedOption === undefined
              ? translatePlaceholder || placeholder === defaultPlaceholderKey
                ? (placeholder | translate)
                : placeholder
              : selectedOption?.label
          }}
        </span>
      </div>
    </ng-template>

    @if (locked && showLockIcon) {
      <i class="lock fi-lock-closed-filled"></i>
    } @else {
      <i class="arrow" [ngClass]="{ 'fi-cheveron-up': isOpen, 'fi-cheveron-down': !isOpen }"></i>
    }
  </button>

  <ng-template #dropdownTemplate>
    <div class="dropdown-menu">
      @if (searchTarget.length > 0) {
        <div class="search">
          <cs-input
            [placeholder]="
              translateSearchPlaceholder || searchPlaceholder === defaultSearchPlaceholderKey
                ? (searchPlaceholder | translate)
                : searchPlaceholder
            "
            prefixIconName="fi-search"
            marginBottom="0"
            [(value)]="searchKeyWord"
            (valueChange)="search($event)"
            (inputFocus)="onSearchFocus()"
            (inputBlur)="onSearchBlur()"
          ></cs-input>
        </div>
      }
      <div class="option-container">
        <div
          *ngFor="let option of filterOptions"
          class="dropdown-option"
          (pointerdown)="onOptionPointerDown($event, option)"
          (click)="select(option)"
          [class.disabled]="option?.disabled"
          [class.active]="option?.value === selectedOption?.value"
        >
          <ng-container *ngIf="optionTemplate; else defaultOption">
            <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
          </ng-container>

          <ng-template #defaultOption>
            @if (option?.icon) {
              <i [ngClass]="option?.icon"></i>
            } @else if (option?.img) {
              @if (option?.lightImg && isLight) {
                <img [src]="option?.lightImg" />
              } @else {
                <img [src]="option?.img" />
              }
            }
            <span>{{ option?.label || '' }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</div>
